import { render, staticRenderFns } from "./PlanGroupHeader.vue?vue&type=template&id=15519a32&scoped=true&"
import script from "./PlanGroupHeader.vue?vue&type=script&lang=ts&"
export * from "./PlanGroupHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PlanGroupHeader.vue?vue&type=style&index=0&id=15519a32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15519a32",
  null
  
)

export default component.exports